import React, {PureComponent} from 'react';
import PropTypes, {oneOfType} from 'prop-types';
import cx from 'classnames';

import CounterTitle from '../counter-title/CounterTitle';

import styles from './SmallSocialCard.pcss';

class SmallSocialCard extends PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        onClick: PropTypes.func,
        primaryText: PropTypes.string.isRequired,
        secondaryText: oneOfType([PropTypes.string, PropTypes.number]),
        isFriends: PropTypes.bool
    };

    render() {
        const {onClick, children, primaryText, secondaryText, isFriends} = this.props;

        const wrapperClasses = cx(styles.wrapper, {[styles.friends]: isFriends});

        return (
            <button className={wrapperClasses} onClick={onClick}>
                <CounterTitle primaryText={primaryText} secondaryText={secondaryText} />
                <div className={styles.iconsWrapper}>{children}</div>
            </button>
        );
    }
}

export default SmallSocialCard;
